export default (theme) => ({
  root: {
    paddingTop: theme.spacing(3),
  },
  subjectButtonsWrapper: {
    marginTop: theme.spacing(1),
  },
  portlet: {
    flex: 1,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
})
